export let checkNetworkConnectionText = "JvwjXc";
export default {checkNetworkConnectionText};